'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _createComponent = require('./createComponent');

var _createComponent2 = _interopRequireDefault(_createComponent);

var _mapError = require('./mapError');

var _mapError2 = _interopRequireDefault(_mapError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createComponent2.default)(_TextField2.default, _mapError2.default);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form-material-ui/lib/TextField.js
// module id = 1596
// module chunks = 0